import { useState } from "react";
import { useLanguage } from "../../context/hook/useLanguageContext";
import templateBlockchain from "./Blockchain.template";

const Blockchain =()=>{
  const { language } = useLanguage();
  const screenWidthMobile = window.screen.width < 1024
  const [showMenu, setShowMenu] = useState(false);
  const onClick = () => {
    setShowMenu(!showMenu)
  }
  return templateBlockchain(language, screenWidthMobile, showMenu, onClick);
}

export default Blockchain;